import { Type, type Static } from '@sinclair/typebox';
import { FIELD_LIMITS } from '../constants.js';
import { RowVersionField, SoftDeleteFields, TimestampFields, UuidSchema } from './common.js';

const NullableText = (maxLength: number) =>
  Type.Union([Type.String({ maxLength }), Type.Null()]);

export const DepartmentSchema = Type.Object({
  id: UuidSchema,
  clientId: Type.Union([UuidSchema, Type.Null()]),
  parentDepartmentId: Type.Union([UuidSchema, Type.Null()]),
  name: Type.String({ minLength: 1, maxLength: FIELD_LIMITS.NAME_MAX }),
  contactName: NullableText(FIELD_LIMITS.NAME_MAX),
  address: NullableText(FIELD_LIMITS.ADDRESS_MAX),
  phone: NullableText(FIELD_LIMITS.PHONE_MAX),
  email: NullableText(FIELD_LIMITS.EMAIL_MAX),
  fax: NullableText(FIELD_LIMITS.PHONE_MAX),
  notes: NullableText(FIELD_LIMITS.NOTES_MAX),
  isActive: Type.Boolean(),
  ...TimestampFields,
  ...SoftDeleteFields,
  ...RowVersionField,
});
export type Department = Static<typeof DepartmentSchema>;

export const DepartmentCreateSchema = Type.Object({
  clientId: UuidSchema,
  parentDepartmentId: Type.Optional(Type.Union([UuidSchema, Type.Null()])),
  name: Type.String({ minLength: 1, maxLength: FIELD_LIMITS.NAME_MAX }),
  contactName: Type.Optional(Type.String({ maxLength: FIELD_LIMITS.NAME_MAX })),
  address: Type.Optional(Type.String({ maxLength: FIELD_LIMITS.ADDRESS_MAX })),
  phone: Type.Optional(Type.String({ maxLength: FIELD_LIMITS.PHONE_MAX })),
  email: Type.Optional(Type.String({ maxLength: FIELD_LIMITS.EMAIL_MAX })),
  fax: Type.Optional(Type.String({ maxLength: FIELD_LIMITS.PHONE_MAX })),
  notes: Type.Optional(Type.String({ maxLength: FIELD_LIMITS.NOTES_MAX })),
});
export type DepartmentCreate = Static<typeof DepartmentCreateSchema>;

export const DepartmentUpdateSchema = Type.Object({
  clientId: Type.Optional(UuidSchema),
  parentDepartmentId: Type.Optional(Type.Union([UuidSchema, Type.Null()])),
  name: Type.Optional(Type.String({ minLength: 1, maxLength: FIELD_LIMITS.NAME_MAX })),
  contactName: Type.Optional(NullableText(FIELD_LIMITS.NAME_MAX)),
  address: Type.Optional(NullableText(FIELD_LIMITS.ADDRESS_MAX)),
  phone: Type.Optional(NullableText(FIELD_LIMITS.PHONE_MAX)),
  email: Type.Optional(NullableText(FIELD_LIMITS.EMAIL_MAX)),
  fax: Type.Optional(NullableText(FIELD_LIMITS.PHONE_MAX)),
  notes: Type.Optional(NullableText(FIELD_LIMITS.NOTES_MAX)),
  isActive: Type.Optional(Type.Boolean()),
  rowVersion: Type.Integer({ minimum: 0 }),
});
export type DepartmentUpdate = Static<typeof DepartmentUpdateSchema>;
